import { mergeClasses } from 'minimal-shared/utils';
import { Splide, SplideSlide } from '@splidejs/react-splide';

import NoSsr from '@mui/material/NoSsr';

import { Image } from 'src/components/image';
import { VideoPlayer } from 'src/components/media-player';

import { GallerySkeleton } from '../product-skeleton';

// ----------------------------------------------------------------------

export function GalleryCarousel({ id, alt, gallery, available, isVisible, showMore }) {
  const galleryStyles = {
    width: 1,
    borderRadius: { sm: 1.5 },
    ...(!available && { opacity: 0.48, filter: 'grayscale(1)' }),
  };

  const mediaProps = {
    className: mergeClasses('product__media', { show__more: showMore }),
    sx: {
      aspectRatio: { sm: '1/1' },
      objectFit: { xs: 'contain', sm: 'cover' },
    },
  };

  return (
    <NoSsr fallback={<GallerySkeleton />}>
      <Splide
        className="splide__product"
        aria-label={`gallery-slider-${id}`}
        options={{ snap: true, arrows: false }}
      >
        {gallery.map(({ src, type }, index) => (
          <SplideSlide key={index}>
            {type.includes('video') ? (
              <VideoPlayer
                alt={alt}
                src={src}
                available={available}
                isVisible={isVisible}
                slotProps={{ video: mediaProps }}
                sx={galleryStyles}
              />
            ) : (
              <Image
                alt={alt}
                src={src}
                ratio={{ sm: '1/1' }}
                slotProps={{ img: mediaProps }}
                sx={galleryStyles}
              />
            )}
          </SplideSlide>
        ))}
      </Splide>
    </NoSsr>
  );
}
